import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const AUTO_DISMISS_MS = 3000;

const WorkspaceTile = ({ name }) => (
  <div className="relative w-9 h-9 rounded-lg flex-shrink-0">
    <div className="absolute inset-0 rounded-lg p-[1.5px] bg-gradient-to-br from-blue-400 via-cyan-400 to-purple-400 shadow-md shadow-cyan-500/20">
      <div className="w-full h-full rounded-[6.5px] bg-white dark:bg-gray-900 flex items-center justify-center">
        <span className="text-sm font-bold bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 bg-clip-text text-transparent">
          {(name || '?').charAt(0).toUpperCase()}
        </span>
      </div>
    </div>
  </div>
);

const WorkspaceSwitchedToast = () => {
  const { lastSwitchEvent, dismissSwitchToast } = useAuth();
  // Mirror the event so the toast can finish its exit animation after dismiss
  const [event, setEvent] = useState(null);
  const [show, setShow] = useState(false);
  const dismissTimerRef = useRef(null);
  const removeTimerRef = useRef(null);

  useEffect(() => {
    if (!lastSwitchEvent) return;

    // Reset any pending timers so a rapid second switch re-triggers cleanly
    clearTimeout(dismissTimerRef.current);
    clearTimeout(removeTimerRef.current);

    setEvent(lastSwitchEvent);
    setShow(true);

    dismissTimerRef.current = setTimeout(() => {
      setShow(false);
      // Wait for the fade-out before clearing — keeps the DOM mount stable mid-animation
      removeTimerRef.current = setTimeout(() => {
        setEvent(null);
        dismissSwitchToast();
      }, 200);
    }, AUTO_DISMISS_MS);

    return () => {
      clearTimeout(dismissTimerRef.current);
      clearTimeout(removeTimerRef.current);
    };
  }, [lastSwitchEvent, dismissSwitchToast]);

  if (!event) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 pointer-events-none">
      <div
        className={`pointer-events-auto flex items-center gap-3 pl-3 pr-5 py-2.5 rounded-xl bg-white dark:bg-gray-900/95 border border-gray-200/80 dark:border-gray-700/60 shadow-2xl shadow-cyan-500/10 dark:shadow-cyan-500/5 backdrop-blur-sm transition-all duration-200 ${
          show ? 'animate-slide-up opacity-100' : 'opacity-0 translate-y-2'
        }`}
      >
        <WorkspaceTile name={event.name} />
        <div className="min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
            Switched to
          </p>
          <p className="text-sm font-semibold text-gray-900 dark:text-white truncate max-w-[260px]">
            {event.name}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceSwitchedToast;
